export const CREATE_PAYMENT_PREF_ERROR_MESSAGE =
  "Error creating payment instruction. Please try again later";

export const LINK_PAYMENT_PREF_ERROR_MESSAGE =
  "Error linking payment pref instruction to accounts. Please try again later";
